import script from "./SkeletonTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonTwo.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonTwo.vue?vue&type=style&index=0&id=51f1eebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f1eebc"]])

export default __exports__